<template>
  <div>
    <app-header><cp-nav></cp-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Chegadas</h2>
      </div>
      <div v-if="horaInicio">
  			<p>Hora de Início: <strong>{{ horaInicio }}</strong></p>
  			<p>Tempo de Prova: <strong>{{ tempoProva }}</strong></p>
  			<hr>
  			<div class="input-group col-md-3 col-xs-12">
  	      <input type="number" pattern="[0-9]*" v-model="dorsal" class="form-control" placeholder="dorsal..." @keyup.enter="regista" autofocus ref='inputDorsal'>
  	      <span class="input-group-btn">
  	        <button class="btn btn-success" type="button" @click="regista()" :disabled="!dorsal || dorsal <= 0">Regista</button>
            <button class="btn btn-danger" type="button" @click="anula()" >Anula</button>
  	      </span>
  	    </div>
  			<hr>
				<p>Volta1: <strong>{{ chegadas.volta1.conta }}</strong> atletas</p>
				<p>Volta2: <strong>{{ chegadas.volta2.conta }}</strong> atletas</p>
				<hr>
  			<div class="table-responsive">
  				<table class="table table-striped tabela">
  					<thead>
  						<tr>
  							<th class="text-left">Dorsal</th>
  							<th class="text-center">Volta</th>
  							<th class="text-center">Tempo</th>
  							<th class="text-right">Hora</th>
  						</tr>
  					</thead>
  					<tbody>
  						<tr v-for="(chegada, index) in chegadas.chegadas" :key="index">
  							<td class="text-left">{{ chegada.dorsal }}</td>
  							<td class="text-center">{{ chegada.volta }}</td>
  							<td class="text-center">{{ chegada.tempo }}</td>
  							<td class="text-right">{{ chegada.hora }}</td>
  						</tr>
  					</tbody>
  				</table>
  			</div>
  	  </div>
  		<div v-if="!horaInicio">
  			<router-link to="/cp/inicio" class="btn btn-default">Início</router-link>
  		</div>
  		<br>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import CpNav from './Nav.vue'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'CpChegadas',
  components: {
    AppHeader,
    CpNav
  },
  data () {
    return {
      horaInicio: '',
			tempoProva: '',
			chegadas: {
				chegadas: [],
				volta1: {
					conta : 0
				},
				volta2: {
					conta : 0
				},
			},
			dorsal: ''
    }
  },
  methods: {
		getHoraPartida() {
			axios.get(process.env.WEB_API + 'getHoraPartida.php')
				.then(response => this.horaInicio = response.data.hora)
		},
		calculaTempoProva() {
			this.tempoProva = moment(moment().diff(moment(this.horaInicio, 'HH:mm:ss'))).format('HH:mm:ss')
		},
		regista() {
			axios.post(process.env.WEB_API + 'setChegada.php', {dorsal: this.dorsal, tempo: this.tempoProva, hora: moment().format('HH:mm:ss')})
				.then(response => this.getUltimasChegadas())
			this.dorsal = ''
			this.$refs.inputDorsal.focus()
		},
    anula() {
			axios.get(process.env.WEB_API + 'deleteChegada.php')
				.then(response => this.getUltimasChegadas())
			this.dorsal = ''
			this.$refs.inputDorsal.focus()
		},
		getUltimasChegadas() {
			axios.get(process.env.WEB_API + 'getUltimasChegadas.php')
				.then(response => this.chegadas = response.data)
		}
	},
	mounted() {
		this.getHoraPartida()
		this.getUltimasChegadas()
		setInterval(function(){
			this.calculaTempoProva()
		}.bind(this), 1000)
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Chegadas.vue?49e2b634